import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const ServicesSection = () => {


  const [items, setItems] = useState([]);
  const [service, setService] = useState([]);


  const [page, setPage] = useState([]);
  const { pageSlug } = useParams(); // Extract the blog post titleSlug from the URL


  useEffect(() => {
    fetch(`https://marchtwo202501-5801b8caeb3a.herokuapp.com/page/${pageSlug}`)
      .then((res) => res.json())
      .then((info) => setPage(info))
      .catch((error) => console.error("Error fetching banners:", error));
  }, []);


  useEffect(() => {
    fetch(`https://marchtwo202501-5801b8caeb3a.herokuapp.com/service-items`)
      .then((res) => res.json())
      .then((info) => setItems(info));
  }, []);


  useEffect(() => {
    fetch(`https://marchtwo202501-5801b8caeb3a.herokuapp.com/service`)
      .then((res) => res.json())
      .then((info) => setService(info));
  }, []);


  return (



    <>
      <section className="feature" id="services-sec">
        {
          service.map(e => e.pageSlug === page.pageSlug && <div className="container">
           
            <h2 className="section-heading color-black">{e.serviceHeading}</h2>
            <div className="row">
              {
                items.map(b => b.pageSlug === page.pageSlug && <div className="col-lg-3 col-md-6">
                  <div className="feature__box feature__box--4">
                    <div className="icon icon-4">
                      <img src={b.serviceIcon} alt="Rocket Launch" className="img-fluid" width="50" height="50" />
                    </div>
                    <div className="feature__box__wrapper">
                      <div className="feature__box--content feature__box--content-4">
                        <h3>{b.serviceTitle}</h3>
                        <p className="paragraph dark">{b.serviceDetails}</p>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>)}
      </section>
    </>


  );
};

export default ServicesSection;
